export interface LandOption {
  code: string;
  name: string;
}

export const LAENDER: LandOption[] = [
  { code: 'DE', name: 'Deutschland' },
  { code: 'AT', name: 'Österreich' },
  { code: 'CH', name: 'Schweiz' },
  { code: 'FR', name: 'Frankreich' },
  { code: 'NL', name: 'Niederlande' },
  { code: 'BE', name: 'Belgien' },
  { code: 'LU', name: 'Luxemburg' },
  { code: 'IT', name: 'Italien' },
  { code: 'ES', name: 'Spanien' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PL', name: 'Polen' },
  { code: 'CZ', name: 'Tschechien' },
  { code: 'SK', name: 'Slowakei' },
  { code: 'HU', name: 'Ungarn' },
  { code: 'DK', name: 'Dänemark' },
  { code: 'SE', name: 'Schweden' },
  { code: 'FI', name: 'Finnland' },
  { code: 'IE', name: 'Irland' },
  { code: 'GB', name: 'Vereinigtes Königreich' },
  { code: 'NO', name: 'Norwegen' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'IS', name: 'Island' },
  { code: 'GR', name: 'Griechenland' },
  { code: 'RO', name: 'Rumänien' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'HR', name: 'Kroatien' },
  { code: 'SI', name: 'Slowenien' },
  { code: 'EE', name: 'Estland' },
  { code: 'LV', name: 'Lettland' },
  { code: 'LT', name: 'Litauen' },
  { code: 'MT', name: 'Malta' },
  { code: 'CY', name: 'Zypern' },
  { code: 'US', name: 'Vereinigte Staaten' },
  { code: 'CA', name: 'Kanada' },
  { code: 'AU', name: 'Australien' },
  { code: 'NZ', name: 'Neuseeland' },
  { code: 'JP', name: 'Japan' },
  { code: 'CN', name: 'China' },
  { code: 'KR', name: 'Südkorea' },
  { code: 'SG', name: 'Singapur' },
  { code: 'HK', name: 'Hongkong' },
  { code: 'IN', name: 'Indien' },
  { code: 'AE', name: 'Vereinigte Arabische Emirate' },
  { code: 'SA', name: 'Saudi-Arabien' },
  { code: 'IL', name: 'Israel' },
  { code: 'TR', name: 'Türkei' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'RS', name: 'Serbien' },
  { code: 'BA', name: 'Bosnien und Herzegowina' },
  { code: 'MK', name: 'Nordmazedonien' },
  { code: 'AL', name: 'Albanien' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'MD', name: 'Moldau' },
  { code: 'BY', name: 'Belarus' },
  { code: 'RU', name: 'Russland' },
  { code: 'GE', name: 'Georgien' },
  { code: 'AM', name: 'Armenien' },
  { code: 'AZ', name: 'Aserbaidschan' },
  { code: 'BR', name: 'Brasilien' },
  { code: 'MX', name: 'Mexiko' },
  { code: 'AR', name: 'Argentinien' },
  { code: 'CL', name: 'Chile' },
  { code: 'ZA', name: 'Südafrika' },
  { code: 'EG', name: 'Ägypten' },
  { code: 'MA', name: 'Marokko' },
  { code: 'TH', name: 'Thailand' },
  { code: 'AD', name: 'Andorra' },
  { code: 'MC', name: 'Monaco' },
  { code: 'SM', name: 'San Marino' },
];

export const EU_LAENDER = new Set([
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR',
  'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO',
  'SE', 'SI', 'SK',
]);

export function laendername(code: string | undefined | null): string {
  const normalized = (code || 'DE').toUpperCase().slice(0, 2);
  return LAENDER.find((land) => land.code === normalized)?.name || normalized;
}
